import metadata from "./ForgotUserIDFormComponent.metadata.json5";
import messages from "./ForgotUserIDFormComponent.messages";
import styles from "./ForgotUserIDFormComponent.module.scss";
import React, { useCallback, useContext, useState } from "react";
import appConfig from 'app-config';
import { ViewModelForm } from "gw-portals-viewmodel-react";
import { TranslatorContext } from '@jutro/locale';
import { CustomValidatorUtil } from "gw-portals-util-js";
import { CustomCRMService } from "gw-capability-profileinfo";

function ForgotUserIDFormComponent(props) {
    const translator = useContext(TranslatorContext);
    const [formData, updateFormData] = useState({});
    const [policyNumberValidationMessages, setPolicyNumberValidationMessages] = useState([]);
    const [zipCodeValidationMessages, setZipCodeValidationMessages] = useState([]);
    const [isPolicySearchFailed, setIsPolicySearchFailed] = useState(false);

    const searchPolicy = useCallback(async() => {
        const verifyCall = await CustomCRMService.getCIAMID(formData.policyNumber);
        if(!_.isEmpty(verifyCall.ciamId)) {
            window.location.href = `${appConfig.env.CIAM_FORGOT_USER_ID_URL}&login_hint=${verifyCall.ciamId}`
        } else {
            setIsPolicySearchFailed(true)
        };
    }, [formData]);

    function hasValidationErrors(fieldValidationMessages) {
        if (!_.isEmpty(fieldValidationMessages) && 
                fieldValidationMessages[0] !== undefined && 
                fieldValidationMessages[0] !== null) {
                    return true;
                }
        return false;
    };
    
    const validationCheck = useCallback((inputValue, inputValidator) => {
        const newValue = inputValue.currentTarget.value;
        switch (inputValidator.id) {
            case 'policyNumber':
                setPolicyNumberValidationMessages([CustomValidatorUtil.policyNumberValidation(newValue)]);
                break;
            case 'zipCode':
                setZipCodeValidationMessages([CustomValidatorUtil.zipCodeValidation(newValue)]);
                break;
            default:
                break;
        }
    });

    const allFieldsEntered = useCallback(() => {
        const { policyNumber, zipCode } = formData;
        if (hasValidationErrors(policyNumberValidationMessages) || 
                hasValidationErrors(zipCodeValidationMessages)) {
            return true;
        }
        
        if (_.isEmpty(policyNumber) || _.isEmpty(zipCode)) {
            return true;
        }
        return false;
    }, [formData, policyNumberValidationMessages, zipCodeValidationMessages]);
    
    const overrideProps = {
        policyholderLoginHeaderText: {
            content: translator(messages.policyholderLoginHeaderText)
        },
        accountRecoveryHeaderText: {
            content: translator(messages.accountRecoveryHeaderText)
        },
        policySearchErrorNotification: {
            visible: isPolicySearchFailed
        },
        policySearchErrorMessage: {
            message: translator(messages.policySearchErrorMessage),
            messageProps: translator(messages.policySearchErrorMessage)
        },
        informationHeaderText: {
            content: translator(messages.informationHeaderText),
            className: 'information-header-text'
        },
        policyNumber: {
            onBlur: validationCheck,
            showErrors: hasValidationErrors(policyNumberValidationMessages),
            validationMessages: policyNumberValidationMessages.filter((n) => n)
        },
        zipCode: {
            onBlur: validationCheck,
            showErrors: hasValidationErrors(zipCodeValidationMessages),
            validationMessages: zipCodeValidationMessages.filter((n) => n)
        },
        forgotUserIDFormContinueButton: {
            content: translator(messages.forgotUserIDFormContinueButtonText),
            disabled: allFieldsEntered(),
            trigger: searchPolicy
        }
    };

    const resolvers = {
            resolveClassNameMap: styles,
        };
    
    const writeValue = useCallback(
        (value, path) => updateFormData({
            ...formData,
            [path]: value
        }),
        [formData]
    );

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={formData}
            overrideProps={overrideProps}
            onValueChange={writeValue}
            classNameMap={resolvers.resolveClassNameMap}
            />
        );
}

export default ForgotUserIDFormComponent;